export default __webpack_public_path__ + "static/media/ero_dark.f4aeb5af.svg";